<template>
  <div class="side-menu-wrapper">
    <slot></slot>
    <!--左侧侧边栏打开的样式-->
    <Menu ref="menu" v-show="!collapsed" active-name="$route.name" accordion width="auto" @on-select="handleSelect" theme="dark">
      <template v-for="item in menuList">
        <template v-if="item.children && item.children.length === 1">
          <side-menu-item v-if="showChildren(item)" :key="`menu-${item.name}`" :parent-item="item"></side-menu-item>
          <menu-item v-else :name="getNameOrHref(item, true)" :key="`menu-${item.children[0].name}`">
            <commonIcon :type="item.children[0].icon || ''"/>
            <span>{{ getTitle(item.children[0]) }}</span>
          </menu-item>
        </template>
        <template v-else>
          <side-menu-item v-if="showChildren(item)" :key="`menu-${item.name}`" :parent-item="item"></side-menu-item>
          <menu-item v-else :name="getNameOrHref(item)" :key="`menu-${item.name}`">
            <commonIcon :type="item.icon || ''"/>
            <span>{{ getTitle(item) }}</span>
          </menu-item>
        </template>
      </template>
    </Menu>

    <!--左侧侧边栏收缩后的样式,如果有子目录则弹出下拉菜单，无子目录则弹出Tooltip 文字提示-->
    <div class="menu-collapsed" v-show="collapsed" :list="menuList">
      <template v-for="item in menuList">
        <collapsed-menu v-if="item.children && item.children.length > 1"
                        @on-click="handleSelect" hide-title
                        :root-icon-size="rootIconSize"
                        :icon-size="iconSize"
                        :theme="theme"
                        :parent-item="item"
                        :key="`drop-menu-${item.name}`">
        </collapsed-menu>
        <Tooltip transfer v-else :content="getTitle(item.children && item.children[0] ? item.children[0] : item)" placement="right" :key="`drop-menu-${item.name}`">
          <a @click="handleSelect(getNameOrHref(item, true))" class="drop-menu-a" :style="{textAlign: 'center'}">
            <commonIcon :size="rootIconSize" :color="textColor" :type="item.icon || (item.children && item.children[0].icon) || default_menu_icon"/>
          </a>
        </Tooltip>
      </template>
    </div>
  </div>

</template>

<script>
  import CollapsedMenu from './collapsed-menu.vue'
  import SideMenuItem from './side-menu-item.vue'
  import layoutMixin from './layout-mixin'

  export default {
    name: "side-menu",
    components:{CollapsedMenu,SideMenuItem},
    mixins:[layoutMixin],
    props:{
      menuList:{
        type:Array,
        default: () => []
      },
      //菜单栏图标尺寸
      rootIconSize: {
        type: Number,
        default: 20
      },
      iconSize: {
        type: Number,
        default: 16
      },
      //菜单栏是否收缩
      collapsed: {
        type: Boolean
      },
      theme: {
        type: String,
        default: 'dark'
      },

    },
    methods:{
      handleSelect (name) {
        this.$emit('on-select', name)
      },
      updateOpenName (name) {
        if (name === this.$config.HOME_PAGE) this.openedNames = []
        else this.openedNames = this.$route.matched.map(item => item.name).filter(item => item !== name)
      }
    },
    computed:{
      textColor () {
        return this.theme === 'dark' ? '#fff' : '#495060'
      }
    }
  }
</script>

<style lang="less">
  .side-menu-wrapper{
    user-select: none;
    .menu-collapsed{
      padding-top: 10px;

      .ivu-dropdown{
        width: 100%;
        .ivu-dropdown-rel a{
          width: 100%;
        }
      }
      .ivu-tooltip{
        width: 100%;
        .ivu-tooltip-rel{
          width: 100%;
        }
        .ivu-tooltip-popper .ivu-tooltip-content{
          .ivu-tooltip-arrow{
            border-right-color: #fff;
          }
          .ivu-tooltip-inner{
            background: #fff;
            color: #495060;
          }
        }
      }
    }
    a.drop-menu-a{
      display: inline-block;
      padding: 6px 15px;
      width: 100%;
      text-align: center;
      color: #495060;
    }
  }
  .menu-title{
    padding-left: 6px;
  }

</style>
